import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36370c76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = {
  key: 0,
  class: "filter-block bg-white filter-category mb-3 px-4 pb-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-bold py-3 d-block" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block py-1" }, "Categorías")
], -1))
const _hoisted_5 = {
  class: "filter-block-options category-options",
  id: "categoriesMap"
}
const _hoisted_6 = { class: "list-unstyled pt-2 mb-0 c-list-categories" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "dot mr-2"
}
const _hoisted_9 = {
  key: 1,
  class: "dot mr-2"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "dot mr-2"
}
const _hoisted_12 = {
  key: 1,
  class: "dot mr-2"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "dot mr-2" }, "-", -1))
const _hoisted_15 = { class: "col-9" }
const _hoisted_16 = { class: "d-flex align-items-end" }
const _hoisted_17 = {
  key: 0,
  class: "mr-1 text-right d-flex align-items-center"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small mb-0 flex-1 mr-1" }, "Talla:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Todas", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 1,
  class: "mr-1 text-right d-flex align-items-center"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small mb-0 flex-1 mr-1" }, "Marca:", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Todas", -1))
const _hoisted_24 = ["value"]
const _hoisted_25 = {
  key: 2,
  class: "mr-1 text-right d-flex align-items-center"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small mb-0 flex-1 mr-1" }, "Color:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Todos", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 3,
  class: "mr-1 text-right d-flex align-items-center"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small mb-0 flex-1 mr-1" }, "Tipo:", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Seleccionar", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = {
  key: 4,
  class: "mr-1 text-right d-flex align-items-center"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small mb-0 flex-1 mr-1" }, "Edad:", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Seleccionar", -1))
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 5,
  class: "mr-1 text-right d-flex align-items-center"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small mb-0 flex-1 mr-1" }, "Género:", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Ambos", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "masculine" }, "Masculino", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "feminine" }, "Femenino", -1))
const _hoisted_42 = [
  _hoisted_39,
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "ml-auto text-right d-flex align-items-center" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small mb-0 flex-1 mr-1 text-nowrap" }, "Ordenar por:", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "relevance" }, "Relevancia", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "lower" }, "Más barato", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "upper" }, "Más caro", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "views" }, "Más vistos", -1))
const _hoisted_49 = [
  _hoisted_45,
  _hoisted_46,
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = { class: "mb-3 mt-2 small font-italic light mr-auto" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = {
  key: 0,
  class: "my-4 text-center"
}
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Nada encontrado por ahora ")
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" =(")
const _hoisted_60 = [
  _hoisted_57,
  _hoisted_58,
  _hoisted_59
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCard = _resolveComponent("ProductCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.categories.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, key) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "pointer",
                    key: key
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["d-flex align-items-start py-1 pointer font-weight-semibold small", category.selected || category.slug === _ctx.query.category ? 'text-primary' : 'text-body']),
                      onClick: ($event: any) => (_ctx.selectCategory(_ctx.categories, category))
                    }, [
                      (!category.drilled && category.categories.length > 0)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_8, "+"))
                        : _createCommentVNode("", true),
                      ((category.drilled && category.categories.length > 0) || category.categories.length === 0)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_9, "-"))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(category.name), 1)
                    ], 10, _hoisted_7),
                    (category.categories.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", {
                          key: 0,
                          class: _normalizeClass(["list-unstyled pl-4", category.drilled ? 'd-block' : 'd-none'])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.categories, (subcategory, key) => {
                            return (_openBlock(), _createElementBlock("li", {
                              class: "pointer",
                              key: key
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["d-flex align-items-start py-1 pointer font-weight-semibold small", subcategory.selected ? 'text-primary' : 'text-body']),
                                onClick: ($event: any) => (_ctx.selectCategory(category.categories, subcategory))
                              }, [
                                (!subcategory.drilled && subcategory.categories.length > 0)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_11, "+"))
                                  : _createCommentVNode("", true),
                                ((subcategory.drilled && subcategory.categories.length > 0) || subcategory.categories.length === 0)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_12, "-"))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(subcategory.name), 1)
                              ], 10, _hoisted_10),
                              (subcategory.categories.length > 0)
                                ? (_openBlock(), _createElementBlock("ul", {
                                    key: 0,
                                    class: _normalizeClass(["list-unstyled pl-4", subcategory.drilled ? 'd-block' : 'd-none'])
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcategory.categories, (subsubcategory, key) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        class: "pointer",
                                        key: key
                                      }, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["d-flex align-items-start py-1 pointer font-weight-semibold small", subsubcategory.selected ? 'text-primary' : 'text-body']),
                                          onClick: ($event: any) => (_ctx.selectCategory(subcategory.categories, subsubcategory))
                                        }, [
                                          _hoisted_14,
                                          _createTextVNode(" " + _toDisplayString(subsubcategory.name), 1)
                                        ], 10, _hoisted_13)
                                      ]))
                                    }), 128))
                                  ], 2))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 2))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        (_ctx.sizes.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _hoisted_18,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.size) = $event)),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pushSearch && _ctx.pushSearch(...args))),
                class: "custom-select custom-select-sm w-auto"
              }, [
                _hoisted_19,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizes, (size, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: size.id
                  }, _toDisplayString(size.name), 9, _hoisted_20))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.query.size]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.brands.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _hoisted_22,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.brand) = $event)),
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pushSearch && _ctx.pushSearch(...args))),
                class: "custom-select custom-select-sm w-auto"
              }, [
                _hoisted_23,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brands, (brand, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: brand.slug
                  }, _toDisplayString(brand.name), 9, _hoisted_24))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.query.brand]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.colors.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _hoisted_26,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.color) = $event)),
                onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.pushSearch && _ctx.pushSearch(...args))),
                class: "custom-select custom-select-sm w-auto"
              }, [
                _hoisted_27,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: color.id
                  }, _toDisplayString(color.name), 9, _hoisted_28))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.query.color]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filters.includes('type'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.query.brand) = $event)),
                class: "custom-select custom-select-sm w-auto"
              }, _hoisted_32, 512), [
                [_vModelSelect, _ctx.query.brand]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.ages.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _hoisted_34,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.query.age) = $event)),
                onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.pushSearch && _ctx.pushSearch(...args))),
                class: "custom-select custom-select-sm w-auto"
              }, [
                _hoisted_35,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ages, (age, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: key,
                    value: age.id
                  }, _toDisplayString(age.name), 9, _hoisted_36))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.query.age]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.filters.includes('gender'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.query.gender) = $event)),
                onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.pushSearch && _ctx.pushSearch(...args))),
                class: "custom-select custom-select-sm w-auto"
              }, _hoisted_42, 544), [
                [_vModelSelect, _ctx.query.gender]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.query.sort) = $event)),
            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getFullSearch())),
            class: "custom-select custom-select-sm w-auto"
          }, _hoisted_49, 544), [
            [_vModelSelect, _ctx.query.sort]
          ])
        ])
      ]),
      _createElementVNode("label", _hoisted_50, [
        _createTextVNode(_toDisplayString(_ctx.products.length) + " productos encontrado(s) ", 1),
        (_ctx.useFilters())
          ? (_openBlock(), _createElementBlock("span", _hoisted_51, "con los siguientes filtros"))
          : _createCommentVNode("", true),
        _hoisted_52
      ]),
      _hoisted_53,
      _createElementVNode("div", _hoisted_54, [
        _createElementVNode("div", _hoisted_55, [
          (_ctx.products.length === 0)
            ? (_openBlock(), _createElementBlock("h5", _hoisted_56, _hoisted_60))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "col-12 col-md-3 px-1 mb-2"
          }, [
            _createVNode(_component_ProductCard, { product: item }, null, 8, ["product"])
          ]))
        }), 128))
      ])
    ])
  ]))
}